import { Quote, Star } from "lucide-react";
import { useI18n } from "../../i18n";

const NAMES = ["Arjun R.", "Priya M.", "Daniel K.", "Rohit S."];

export default function Proof() {
  const { t, currency, fmtCcy } = useI18n();
  const STATS = [
    { v: "XAUUSD", l: t("stat1_l") },
    { v: "2025+", l: t("stat2_l") },
    { v: "0", l: t("stat3_l") },
    { v: fmtCcy(currency.price), l: t("stat4_l") },
  ];
  return (
    <section id="proof" className="relative py-16 sm:py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5 sm:gap-3 mb-12 sm:mb-14">
          {STATS.map((s, i) => (
            <div key={i} className="panel p-4 sm:p-5 text-center">
              <div className="font-display font-black text-2xl sm:text-3xl lg:text-4xl text-[color:var(--gold)] glow-gold">{s.v}</div>
              <div className="font-mono text-[9px] sm:text-[10px] uppercase tracking-widest text-[color:var(--ink-mute)] mt-2">{s.l}</div>
            </div>
          ))}
        </div>

        <div className="max-w-2xl">
          <span className="chip">{t("proof_chip")}</span>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl mt-5 leading-[1.05]">
            {t("proof_h1_a")} <span className="text-[color:var(--gold)]">{t("proof_h1_b")}</span>
          </h2>
          <p className="text-[color:var(--ink-dim)] mt-4 text-sm sm:text-base">{t("proof_sub")}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-3 sm:gap-4 mt-8 sm:mt-10">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} data-testid={`testimonial-${i}`} className="panel p-5 sm:p-6">
              <Quote className="w-5 h-5 text-[color:var(--gold)]" />
              <p className="text-[14px] sm:text-[15px] text-white/90 mt-3 leading-relaxed">"{t(`test${i}_txt`)}"</p>
              <div className="flex items-center justify-between mt-4 sm:mt-5">
                <div>
                  <div className="font-display font-bold text-sm">{NAMES[i - 1]}</div>
                  <div className="font-mono text-[10px] sm:text-[11px] text-[color:var(--ink-mute)] uppercase tracking-widest">{t(`test${i}_role`)}</div>
                </div>
                <div className="flex gap-0.5">
                  {[0, 1, 2, 3, 4].map((s) => <Star key={s} className="w-3.5 h-3.5 fill-[color:var(--gold)] text-[color:var(--gold)]" />)}
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-[11px] sm:text-xs text-[color:var(--ink-mute)] mt-6 sm:mt-8 max-w-3xl">{t("proof_disclaimer")}</p>
      </div>
    </section>
  );
}
